import { Assignments } from "classes/models/assignments/assignment.model";

export const useSortAssignments = (assignments: Assignments) => {
  return assignments.sort((a, b) => {
    // If the assignments have a display order sort by that from lowest to highest
    if (a.displayOrder != undefined && b.displayOrder != undefined) {
      if (a.displayOrder < b.displayOrder) return -1;
      if (a.displayOrder > b.displayOrder) return 1;
    }

    var aDueTimestamp = a.dueTimestamp;
    var bDueTimestamp = b.dueTimestamp;
    var aOpenTimestamp = a.openTimestamp;
    var bOpenTimestamp = b.openTimestamp;

    if (
      aDueTimestamp == undefined &&
      bDueTimestamp == undefined &&
      aOpenTimestamp == undefined &&
      bOpenTimestamp == undefined
    ) {
      return a.name.localeCompare(b.name);
    }

    if (aDueTimestamp == undefined || bDueTimestamp == undefined) return 0;

    if (aDueTimestamp < bDueTimestamp) return -1;

    if (aDueTimestamp > bDueTimestamp) return 1;

    if (aOpenTimestamp == undefined || bOpenTimestamp == undefined) return 0;

    if (aOpenTimestamp < bOpenTimestamp) return -1;

    if (aOpenTimestamp > bOpenTimestamp) return 1;

    return 0;
  });
};
